import React from 'react'
import {MDXProvider} from '@mdx-js/react'

const Template = ({children, ...props}) => {
  return (
    <>
      <MDXProvider>{children}</MDXProvider>
    </>
  )
}

export default Template
